// @flow

import { camelCase, get, isEmpty } from 'lodash';

import TrackData from 'app/track/Data';

type SignupFormat = 'button' | 'link';
type SignupPosition =
  | 'river_1'
  | 'river_2'
  | 'river_3'
  | 'getStarted'
  | 'testimonials';

export type HomepageV2EventShape = {|
  ctaName: string,
  path: string,
  referrer: string,
  signupFormat: SignupFormat,
  signupPosition: SignupPosition,
  useCaseSlug: string,
|};

export default () => {
  const homepageCtas = document.querySelectorAll('.js-homepage-tracking');

  const handleHomepageCta = (e: MouseEvent) => {
    const dataAttributes = get(e, ['target', 'dataset'], {});
    const ctaName = get(e, ['target', 'text'], '');
    const path = get(document, ['location', 'pathname']);
    const referrer = get(document, ['referrer'], '');

    if (isEmpty(dataAttributes)) {
      return;
    }

    const {
      trackingFormat,
      trackingPosition,
      trackingUseCaseSlug,
    } = dataAttributes;

    TrackData.recordHomepageV2Events({
      ctaName: camelCase(ctaName),
      path,
      referrer,
      signupFormat: trackingFormat,
      signupPosition: trackingPosition,
      useCaseSlug: trackingUseCaseSlug,
    });
  };

  [].slice.call(homepageCtas).forEach(homepageCta => {
    homepageCta.addEventListener('click', handleHomepageCta);
  });

  return null;
};
